import { SentryUserProps, useSentry } from "core/components/SentryProvider";

/**
 * This is just an abstraction layer, we used it to migrate off Bugsnag to Sentry.
 * If in the future we need to migrate again, this can be useful. Look at our useSentry implementation for more. :)
 */

export const useErrorReporter = () => {
  const sentry = useSentry();
  return {
    notify: (err: any) => {
      if (USE_SENTRY) sentry.notify(err);
    },
    setUser: (usr: SentryUserProps) => {
      if (USE_SENTRY) sentry.setUser(usr);
    },
  };
};
